import { connect } from 'react-redux';
import AggregateCheckBoxView from '../../../../../components/users/AggregateCheckBox';
import { aggregateUsers } from '../../../../../actions/dashboards/users';
import { isDashboardsUsersAggregateEnabled } from '../../../../../reducers/analyticsApp';

const mapStateToProps = (state, { unit }) => ({
  cacheEnabled: isDashboardsUsersAggregateEnabled(state, unit.id),
});

const mapDispatchToProps = (dispatch, { unit }) => ({
  onChange: () => dispatch(aggregateUsers(unit.id)),
});

const AggregateCheckBox = connect(mapStateToProps, mapDispatchToProps)(AggregateCheckBoxView);

export default AggregateCheckBox;
